export const NAME_REGEXP = /[a-zA-Zа-яА-я]/;
export const EMAIL_REGEXP =
	/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i;

export const NUMERIC_REGEXP = /[^0-9\.]/g;
